import { render, staticRenderFns } from "./equipmentDetail.vue?vue&type=template&id=898ed7f6&scoped=true"
import script from "./equipmentDetail.vue?vue&type=script&lang=js"
export * from "./equipmentDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "898ed7f6",
  null
  
)

export default component.exports